import { exportCardDebtorPdf } from "./CardDebtor";

// ─── card data mapping: ข้อมูลสัญญา(เก่า) จาก loanData.LOAN ───
const buildLoanOldCardData = (loan) => ({
  newContno: loan?.CONTNO,
  sdate: loan?.SDATE,
  grdcod: loan?.GRDCOD,
  financedAmount: loan?.TOTPRC,
  totalAmount: loan?.TOTPRC,
  totalPaid: loan?.SMPAY,
  installment: loan?.TOT_UPAY,
  installmentCount: loan?.T_NOPAY,
  firstDueDate: loan?.FDATE,
  lastDueDate: loan?.LDATE,
  lastPaymentDate: loan?.LPAYD,
  lastPaymentAmount: loan?.LPAYA,
  expFrm: loan?.EXP_FRM,
  expTo: loan?.EXP_TO,
  expPrd: loan?.EXP_PRD,
  holdNo: null,
  outstanding: loan?.EXP_AMT,
  oldContno: loan?.ISSUNO,
});

// ─── main export ────────────────────────────────────────────
// การ์ดลูกหนี้ของสัญญาเก่า: ใช้ layout เดียวกับ CardDebtor
// ข้อมูลจาก loanData (LOAN, CUSTOMER, GUARANTORS, MORTGAGE) + judgeData (note, ผู้ติดตาม)
export const exportCardDebtorOldPdf = async ({
  loanData,
  judgeData,
  remarkValueOld,
}) => {
  const loan = loanData?.LOAN;
  if (!loan) return;

  await exportCardDebtorPdf({
    loanNew: loan, // ใช้คำนวณยอดจ่ายขั้นต่ำ (GRDCOD, TOT_UPAY)
    customer: loanData?.CUSTOMER,
    guarantors: loanData?.GUARANTORS,
    mortgage: loanData?.MORTGAGE,
    remarkValueOld,
    judgeData,
    cardData: buildLoanOldCardData(loan),
    title: "การ์ดลูกหนี้",
  });
};

export default exportCardDebtorOldPdf;
